import { useLayoutEffect, useState } from 'react';

/**
 * Get sizes
 */
const getWindowSize = () => ({
  width: window.innerWidth,
  height: window.innerHeight
});

/**
 * Use window sizes
 */
const useWindowSize = () => {
  let [{ width, height }, set] = useState(getWindowSize());
  let listener = () => {
    set(getWindowSize());
  };

  useLayoutEffect(() => {
    window.addEventListener('resize', listener);

    return () => {
      window.removeEventListener('resize', listener);
    };
  }, []);

  width > 1000 ? set({ width: 1000, height }) : width;
  return {
    width,
    height,
    refresh: listener
  };
};

export { useWindowSize, getWindowSize };
